import { RegisterRRPCError } from "@vierkant-software/remoterpc";
import { BaseError } from "./base-error";

@RegisterRRPCError("MissingResource")
export class MissingResource extends BaseError {
    status = "CALENDAR:NORESOURCE";
    constructor(type: string = "Resource"){
        super();
        this.args = {
            type
        };
    }
}
